var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pre',{staticClass:"line-numbers",class:("language-" + _vm.lang)},[_vm._v("    "),_c('code',[_vm._v("\n    "),_vm._t("default",[_vm._v("\n    ")]),_vm._v("\n    ")],2),_vm._v("\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }